<div *ngIf="conectando" class="alert alert-info">
  <i class="fe-loader"></i> Verificando QZ Tray...
</div>

<ng-container *ngIf="!this.conectando && !this.qzInstalado && !this.isMobile">
  <div class="form-group mb-4 col-12" >
    <label [hidden]="!titulo">{{titulo}}</label><br>
    <div class="qz-error-notification">
      <div class="notification-content">
        <i class="fas fa-print notification-icon"></i>
        <div class="notification-message">
          <strong>Impressora não conectada</strong>
          <p>Verifique se o QZ Tray está em execução no seu computador</p>
        </div>
      </div>
      <div class="notification-actions">
        <button (click)="tenteConectarQZ()" class="btn btn-warning waves-effect waves-light mr-2" [disabled]="conectando">
          <i class="fas fa-sync fa-fw"></i>
          Tentar novamente
        </button>
        <button (click)="abraQZTray()" class="btn btn-primary waves-effect waves-light" [disabled]="conectando" type="button">
          <i class="fas fa-external-link-alt fa-fw"></i>
          Abrir QZ Tray
        </button>
      </div>
    </div>
  </div>
</ng-container>



